import React, { useMemo } from "react";

import MultiLayerEditPanelContent from "fond/draw/MultiLayerEdit/MultiLayerEditPanelContent";
import { MultiLayerEditLegacyProvider } from "fond/draw/MultiLayerEdit/MultiLayerEditProviderLegacy";
import { getCurrentProjectData } from "fond/project";
import { LayerIds } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

import { getEditFeatures, makeEditDrawOptions, makeEditingLayers, makeEditToolbarConfig } from "./editConfig";

const LAYER_IDS = [LayerIds.inAddress, LayerIds.inLeadIns, LayerIds.inStreetPoints, LayerIds.inStreet, LayerIds.inSpan, LayerIds.inPole];

const allToolConfig = makeEditToolbarConfig(["Point", "LineString"]);

/**
 * This component is responsible for managing the drawing of Lead Ins and Underground layers
 * for Extended Design data prep modifications.
 */
const ModificationsDraw: React.FC = () => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const projectData = useAppSelector((state) => getCurrentProjectData(state.project));

  const defaultOptions = useMemo(() => makeEditDrawOptions({ layers: makeEditingLayers(LAYER_IDS), editingLayerId: LayerIds.inLeadIns }), []);

  // Get features from Redux (same source as MapContent) to ensure IDs match what's on the map
  const initialFeatures = useMemo(() => getEditFeatures(projectData?.layers, LAYER_IDS), [projectData]);

  return (
    <MultiLayerEditLegacyProvider versionId={versionId} options={defaultOptions} config={allToolConfig} initialFeatures={initialFeatures}>
      <MultiLayerEditPanelContent />
    </MultiLayerEditLegacyProvider>
  );
};

export default ModificationsDraw;
